import React from 'react';
import ProjectContent from '../components/ProjectContent';

const RobTheMafia = () => <ProjectContent projectName='Rob the Mafia'/>;

export default RobTheMafia;